export const addToken = (payload) => ({
    type: 'ADD_LOGIN_TOKEN',
    payload
})

export const removeToken = () => ({
    type: 'REMOVE_LOGIN_TOKEN'
})